import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

interface ImagePostModalData {
  postId?: number;
  imageURL?: string[];
  initialIndex?: number;
}

interface ImagePostModalContextType {
  isOpen: boolean;
  data: ImagePostModalData | null;
  openModal: (data: any) => void;
  closeModal: () => void;
  setData: Dispatch<SetStateAction<ImagePostModalData | null>>;
}

const ImagePostModalContext = createContext<
  ImagePostModalContextType | undefined
>(undefined);

export const ImagePostModalProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<ImagePostModalData | null>(null);

  const openModal = (modalData: ImagePostModalData) => {
    setData(modalData);
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    setData(null);
    document.body.style.overflow = "initial";
  };

  return (
    <ImagePostModalContext.Provider
      value={{ isOpen, data, openModal, closeModal, setData }}
    >
      {children}
    </ImagePostModalContext.Provider>
  );
};

export const useImagePostModal = () => {
  const context = useContext(ImagePostModalContext);
  if (!context) {
    throw new Error(
      "useImagePostModal must be used within an ImagePostModalProvider",
    );
  }
  return context;
};
